import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Onboarding.module.css';

interface Option {
  value: string;
  optionTextKey: string;
}

interface MultiChoiceProps {
  questionTextKey: string;
  options: Option[];
  value: string[];
  onChange: (value: string[]) => void;
}

const MultiChoice: React.FC<MultiChoiceProps> = ({
  options,
  value,
  onChange
}) => {
  const { t } = useTranslation();

  const handleToggle = (optionValue: string) => {
    const newValue = value.includes(optionValue)
      ? value.filter(v => v !== optionValue)
      : [...value, optionValue];
    onChange(newValue);
  };

  return (
    <div className={styles.multiChoiceContainer}>
      {options.map((option) => {
        const isSelected = value.includes(option.value);
        return (
          <div
            key={option.value}
            className={`${styles.multiChoiceOption} ${isSelected ? styles.multiChoiceOptionSelected : ''}`}
            onClick={() => handleToggle(option.value)}
          >
            <div className={`${styles.checkbox} ${isSelected ? styles.checkboxSelected : ''}`}>
              <svg className={styles.checkIcon} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6667 3.5L5.25 9.91667L2.33333 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span className={styles.multiChoiceOptionText}>
              {t(option.optionTextKey)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default MultiChoice; 